import { render } from "./project.vue?vue&type=template&id=37dc3217"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"

import "./project.vue?vue&type=style&index=0&id=37dc3217&lang=css"

import exportComponent from "/codebuild/output/src3474900079/src/relsify_nft_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__